import { defineStore } from "pinia";
import {
  ADD_CARD,
  YARN_INFO_TYPE,
  YARN_PREVIEW_MODE,
  USER_TYPE,
  YARN_FORM_TYPE,
  SHIMA_USER_MODAL_MODE,
  COMPANY_FORM_TYPE,
  INVITE_MAIL_MODAL_MODE,
  BLOCK_DOWNLOAD_MODAL
} from "~/constants/common";

export const useComponentStore = defineStore("component", () => {
  const addCardType = ref(ADD_CARD.ACTIVE)
  const yarnInfoType = ref(YARN_INFO_TYPE.PART)
  const yarnInfoMode = ref(YARN_PREVIEW_MODE.VIEW)
  const helpType = ref(USER_TYPE.SUPPLIER)
  const yarnFormType = ref(YARN_FORM_TYPE.ADMIN_UPDATE)
  const errorMessage = ref('')
  const isShowSuccessModal = ref(false)
  const successModalTitle = ref('')
  const successModalContents = ref([])
  const adminAccountFormMode = ref(SHIMA_USER_MODAL_MODE.EDIT)
  const categorySearchCountryLength = ref(0)
  const singleInputLabelCols = ref(3)
  const phoneNumberCountry = ref(null)
  const companyFormType = ref(COMPANY_FORM_TYPE.CUSTOMER_UPDATE)
  const inviteModalMode = ref(INVITE_MAIL_MODAL_MODE.SUPPLIER)
  const blockDownloadModal = ref(BLOCK_DOWNLOAD_MODAL.ADD)
  const hasError = ref(false)

  return {
    helpType,
    addCardType,
    yarnInfoType,
    yarnInfoMode,
    errorMessage,
    adminAccountFormMode,
    successModalTitle,
    successModalContents,
    isShowSuccessModal,
    categorySearchCountryLength,
    yarnFormType,
    singleInputLabelCols,
    phoneNumberCountry,
    companyFormType,
    inviteModalMode,
    blockDownloadModal,
    hasError
  }
})